export default __webpack_public_path__ + "8d25d76b92c9752efb81d895251bb67c.png";